import React, { useEffect, useState } from 'react';

import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPen, faX } from '@fortawesome/free-solid-svg-icons';
import { Grid } from '../../components/grid';
import { AlertDismissible } from "../../components/alerts";
import { FormularioModal } from '../../components/ventanaModal';
import { ActualizarPaquetesDeViajes, AgregarPaquetesDeViajes, InactivarPaquetesDeViajes, ObtenerPaquetesDeViajes, ObtenerPaquetesDeViajesPorId } from '../../servicios/ServicioPaquetesDeViajes';
import FormularioPaquetesDeViajes from './FormularioPaquetesDeViajes';


const PaquetesDeViajesComponet = () => {
    const [proceso, setProceso] = useState(1);
    const [modal, setModal] = useState(false);
    const [mensajeFormulario, setMensajeFormulario] = useState("");
    const [data, setData] = useState({});
    const [modalTitulo, setModalTitulo] = useState("Registrar Producto");
    const [labelButton, setLabelButton] = useState("Registrar");
    const [mensajeRespuesta, setMensajeRespuesta] = useState({});
    const [idBuscar, setidBuscar] = useState("");

    const [listaRespaldo, setListaRespaldo] = useState([]);
    const [pendiente, setPendiente] = useState(false);
    const [bloquearBoton, setBloquearBoton] = useState(true);
    const [textoBotonInactivar, setTextoBotonInactivar] = useState("Inactivar");
    const [textoBotonActualizar, setTextoBotonActualizar] = useState("Actualizar");

    const [filaSeleccionada, setFilaSeleccionada] = useState({});
    const [lista, setLista] = useState([]);
    const [showAlert, setShowAlert] = useState(false);

    const [PermisoAgregar, setPermisoAgregar] = useState(false);
    const [PermisoActualizar, setPermisoActualizar] = useState(false);
    const [PermisoEliminar, setPermisoEliminar] = useState(false);

    const encabezado = [
        { id: 'id', name: 'Serie', selector: row => row.id, head: "id", omit: true },
        { id: 'Descripcion', name: 'Descripción', selector: row => row.descripcion, head: "Descripción", sortable: true },
        { id: 'fechaSalida', name: 'F. Salida', selector: row => row.fechaSalida.split('T')[0], head: "Fecha Salida", sortable: true },
        { id: 'fechaLLegada', name: 'F. LLegada', selector: row => row.fechaLLegada.split('T')[0], head: "Fecha Llegada", sortable: true },
        { id: 'precioContado', name: 'Contado ($)', selector: row => row.precioContado, head: "Contado", sortable: true },
        { id: 'precioPlazos', name: 'A PLazos ($)', selector: row => row.precioPlazos, head: "A PLazos", sortable: true },
        { id: 'cantidadCampos', name: 'Pasajeros', selector: row => row.cantidadCampos, head: "Pasajeros", sortable: true },
        { id: 'cantidadGuias', name: 'Guías', selector: row => row.cantidadGuias, head: "Guías", sortable: true },
        { id: 'cantidadCamposDisponibles', name: 'Disponibles', selector: row => row.cantidadCamposDisponibles, head: "Disponibles", sortable: true },
        //{ id: 'fechaCreacion', name: 'F. Creación', selector: row => row.fechaCreacion.split('T')[0], head: "F. Creación" },
        { id: 'estado', name: 'Estado', selector: row => row.estado, head: "Estado", sortable: true },
    ]
    //Se indica las columnas en las que se aplica el filtro
    const filterColumns = ['descripcion'];

    useEffect(() => {
        ObtenerListado();
        ObtenerPermisosUsuario();
    }, []);

    const ObtenerPermisosUsuario = () => {
        let usuario = JSON.parse(sessionStorage.getItem("data_usuario"));
        setPermisoAgregar(usuario.PermisoAgregar ?? false);
        setPermisoActualizar(usuario.PermisoActualizar ?? false);
        setPermisoEliminar(usuario.PermisoEliminar ?? false);


        //aprovecha el metodo para asignar el texto del boton dependiendo del permiso
        if (usuario.PermisoActualizar) {
            setTextoBotonActualizar("Actualizar")
        }
        else {
            setTextoBotonActualizar("Ver Información")
        }


    }

    const ObtenerListado = async () => {
        setPendiente(true);
        setLista(await ObtenerPaquetesDeViajes());
        setListaRespaldo(await ObtenerPaquetesDeViajes());
        setPendiente(false);
    }

    const onClickSeleccionarFila = (fila) => {
        const filaValida = ValidarSiFilaFueSeleccionada(fila);
        setBloquearBoton(!filaValida);
        setTextoBotonInactivar(!filaValida ? "Inactivar" : (fila.estado == "Activo" ? "Inactivar" : "Activar"));
        setFilaSeleccionada(fila);
    }

    const onClickCerrarModal = () => {
        setModal(false);
        setMensajeFormulario("");
    }

    const onClickNuevo = () => {
        setProceso(1);
        setModal(!modal);
        setLabelButton("Registrar");
        setModalTitulo("Registrar Paquete de Viaje");
    }

    const onClickActualizar = async () => {
        setData(await ObtenerPaquetesDeViajesPorId(filaSeleccionada.id));
        setProceso(2);
        setModal(!modal);

        if (!PermisoActualizar) {
            setModalTitulo("Información Paquete de Viaje");
        }
        else {
            setModalTitulo("Actualizar Paquete de Viaje");
        }

        setLabelButton("Actualizar");
    }

    const onClickInactivar = async () => {
        const respuesta = await InactivarPaquetesDeViajes(filaSeleccionada.id)
        if (respuesta.indicador === 0)
            ObtenerListado();
        setMensajeRespuesta(respuesta);
        setTextoBotonInactivar(textoBotonInactivar == "Activar" ? "Inactivar" : "Activar");
    }



    const ValidarSiFilaFueSeleccionada = (fila) => Object.entries(fila).length === 0 ? false : true;


    const onClickProcesar = async (data) => {
        console.log({ ...data });
        let respuesta = {};

        data.TieneRegalias = Boolean(data.TieneRegalias);
        data.TieneDescuentos = Boolean(data.TieneDescuentos);

        if (proceso === 1) {
            respuesta = await AgregarPaquetesDeViajes(data);
        }
        else {
            data.id = filaSeleccionada.id;
            data.estado = true;
            respuesta = await ActualizarPaquetesDeViajes(data);
        }

        if (respuesta.indicador == 0) {
            setModal(false);
            ObtenerListado();
            setMensajeRespuesta(respuesta);
            setShowAlert(true);
        } else {
/*            setMensajeFormulario(respuesta.mensaje);*/
            setMensajeRespuesta(respuesta);
            setShowAlert(true);
        }
    }

    return (
        <>{showAlert && (
            <AlertDismissible
                indicador={mensajeRespuesta.indicador}
                mensaje={mensajeRespuesta.mensaje}
                setShow={setShowAlert}
            />
        )}
            <div className="container-fluid text-no">
                <h1>Administración Paquetes de Viajes</h1>
                <hr />
                {PermisoAgregar && (
                    <>
                        <Button
                            className="mr-1 mb-2 card-button"
                            variant="primary"
                            type="submit"
                            size="sm"
                            onClick={() => onClickNuevo()}>
                            <FontAwesomeIcon icon={faPlus} className="mr-2" />
                            Registrar
                        </Button>{' '}
                    </>
                )}
                <Button
                    className="mr-1 mb-2 card-button"
                    variant="primary"
                    type="submit"
                    size="sm"
                    onClick={() => onClickActualizar()}
                    disabled={bloquearBoton}>
                    <FontAwesomeIcon icon={faPen} className="mr-2" />
                    {textoBotonActualizar}
                </Button>{' '}

                {PermisoEliminar && (
                    <>
                        <Button
                            className="mr-1 mb-2 danger-button"
                            variant="danger"
                            type="submit"
                            size="sm"
                            onClick={() => onClickInactivar()}
                            disabled={bloquearBoton}>
                            <FontAwesomeIcon icon={faX} className="mr-2" />
                            {textoBotonInactivar}
                        </Button>
                    </>
                )}
                <br />

                <span>Listado de Todos los Paquetes Registrados</span>
                <br />
                <Grid
                    gridHeading={encabezado}
                    gridData={listaRespaldo}
                    selectableRows={true}
                    pending={pendiente}
                    setFilaSeleccionada={onClickSeleccionarFila}
                    filterColumns={filterColumns}
                    idBuscar="id" />
                <br />
                <br />

                <FormularioModal
                    show={modal}
                    handleClose={onClickCerrarModal}
                    titulo={modalTitulo} tamano="lg" className=''>
                    <FormularioPaquetesDeViajes
                        labelButton={labelButton}
                        data={data}
                        proceso={proceso}
                        onClickProcesar={onClickProcesar}
                        mensaje={mensajeFormulario}
                        PermisoActualizar={PermisoActualizar}
                        setShowAlert={setShowAlert} />
                </FormularioModal>

            </div>

        </>
    )
}

export default PaquetesDeViajesComponet;